/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */
import "./Navbar.css";
import { Link } from "react-router-dom";
import { Stage } from "../../config/StageConfig";

/**
 * @author stcatai Apr 3, 2024
 */
export enum NavbarPages {
  ModelEntries = "ModelEntries",
  CommitHistory = "CommitHistory",
  Antisignatures = "AntiSignatures"
}

interface NavbarProps {
  selectedPage: NavbarPages;
  stage: Stage;
}

export function Navbar({selectedPage, stage}: NavbarProps) {

  return <div className="navbar">
    <div className="top-content">
      <h4>ModelHub <span className={stage === Stage.Prod ? "prod-color" : "gamma-color"}>{stage}</span></h4>
      <a href="https://w.amazon.com/index.php/RobotDetection/ModelHub/UserDocs">Wiki</a>
    </div>
    <div className="pages">
      <Link to={"/"} className={selectedPage === NavbarPages.ModelEntries ? "selected" : ""}>Model entries</Link>
      <Link to={"/commits"} className={selectedPage === NavbarPages.CommitHistory ? "selected" : ""}>Commit history</Link>
      <Link to={"/antisignatures"} className={selectedPage === NavbarPages.Antisignatures ? "selected": ""}>AntiSignatures</Link>
    </div>
  </div>
}